//@flow

import classnames from 'classnames';
import * as tracking from 'dibs-tracking';

import DepositLinkMessage from '../messages/DepositLinkMessage';

import styles from '../styles/DepositLink.scss';

const trackLinkClick = (
    e: SyntheticEvent<HTMLElement>,
    onClick: (e: SyntheticEvent<HTMLElement>) => mixed
) => {
    e.preventDefault();
    onClick(e);
    tracking.trackEvent({
        category: 'product',
        action: 'deposits details',
        label: 'deposits details clicked',
        value: '0',
    });
};

type DepositLinkProps = {
    label?: React$Node,
    linkText?: React$Node,
    onClick: (e: SyntheticEvent<HTMLElement>) => mixed,
    wrapperClass?: string,
};

const DepositLink = (props: DepositLinkProps) => {
    const { wrapperClass, label, linkText, onClick } = props;
    return (
        <span className={classnames(styles.linkWrapper, wrapperClass)}>
            {label && <span className={styles.label}>{label}</span>}
            <a onClick={e => trackLinkClick(e, onClick)}>{linkText || <DepositLinkMessage />}</a>
        </span>
    );
};

export default DepositLink;
